import { useContext } from 'react';
import { ThemeContext } from '@lib/context/ThemeContextWrapper';

export function useTheme() {
  return useContext(ThemeContext);
}

export default useTheme;
